<template>
    <div class="container">
        <div class="row" v-if="showButtons">
            <div class="col-sm-6"><a class="btn active" href="#">Suche über Marke</a></div>
            <div class="col-sm-6"><a class="btn" href="#">Suche über Kategorie</a></div>
        </div>
        <car-brands></car-brands>
        <car-model-list></car-model-list>
        <car-categories></car-categories>
        <car-search-button v-if="false"></car-search-button>
    </div>
</template>

<script>
export default {

    data() {
        return {
            showButtons: false
        }
    },

    created() {
        new Form().get('/api/selection')
        .then(selection => {
            if (Object.keys(selection).length) {
                App.event.fire('car.selection.loaded', selection);
            }
        });
    }
  
}
</script>
